var EHDI = EHDI || Object.create(null);

EHDI.scene = EHDI.scene || Object.create(null);

EHDI.scene.TitleScene = function() {
    EHDI.aka.Container.call(this);
}

EHDI.scene.TitleScene.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.scene.TitleScene.prototype.screenWillAppear = function() {
    var bg = new PIXI.extras.TilingSprite(EHDI.Assets.images["am_bg"], EHDI.GAME.sceneManager.getStageWidth(), EHDI.GAME.sceneManager.getStageHeight());
    EHDI.GAME.soundManager.autoResumeToggle(true);
    this.addChild(bg);
};

EHDI.scene.TitleScene.prototype.screenDidAppear = function() {
    // this.title = new EHDI.aka.PixiText("The Weeds Among The Grass", {fontFamily: 'Exo-Bold', fill: 0xFFFFFF, fontSize : 50});
    
    var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);

    this.glow = new EHDI.aka.Sprite(EHDI.Assets.images['am_title_glow']);
    this.glow.anchor.set(0.5, 0.5);    
    this.glow.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.5, EHDI.GAME.sceneManager.getStageHeight() * 0.4);

    this.addChild(this.glow);
    
    this.purpleCube = new EHDI.aka.Sprite(EHDI.Assets.images['am_title_cube_01']);
    this.purpleCube.anchor.set(0.5, 0.5);    
    this.purpleCube.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.85, EHDI.GAME.sceneManager.getStageHeight() * 0.3);

    this.addChild(this.purpleCube);

    this.yellowCube = new EHDI.aka.Sprite(EHDI.Assets.images['am_title_cube_02']);
    this.yellowCube.anchor.set(0.5, 0.5);    
    this.yellowCube.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.175, EHDI.GAME.sceneManager.getStageHeight() * 0.4);

    this.addChild(this.yellowCube);
    
    this.blueCube = new EHDI.aka.Sprite(EHDI.Assets.images['am_title_cube_03']);
    this.blueCube.anchor.set(0.5, 0.5);    
    this.blueCube.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.2, EHDI.GAME.sceneManager.getStageHeight() * 0.7);

    this.addChild(this.blueCube);
    
    this.greenCube = new EHDI.aka.Sprite(EHDI.Assets.images['am_title_cube_04']);
    this.greenCube.anchor.set(0.5, 0.5);    
    this.greenCube.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.8, EHDI.GAME.sceneManager.getStageHeight() * 0.675);

    this.addChild(this.greenCube);

    
    this.title = new EHDI.aka.Sprite(EHDI.Assets.images['am_title']);
    this.title.anchor.set(0.5, 0.5);    
    this.title.scale.set(0.85);
    this.title.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.5, EHDI.GAME.sceneManager.getStageHeight() * 0.4);

    this.addChild(this.title);

    this.sound = new EHDI.displays.ToggleButton(EHDI.Assets.images["btn_audio1"], EHDI.Assets.images["btn_audio3"], EHDI.Assets.images["btn_audio2"], EHDI.Assets.images["btn_audio4"], EHDI.GAME.soundManager.getMuted());
    this.sound.setOnClickFunction(this.toggleAudio);
    this.sound.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.1, EHDI.GAME.sceneManager.getStageHeight() * 0.09);
    
    this.addChild(this.sound);

     this.closeBtn = new EHDI.displays.Button(EHDI.Assets.images["btn_close"], null, null, null,0.8);
  this.closeBtn.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.96, EHDI.GAME.sceneManager.getStageHeight() * 0.09);
  this.closeBtn.setOnClickFunction(function(){
    location.href = "?isGameStarted=false"
  });
  this.addChild(this.closeBtn);
    
    this.highScoreHolder = new EHDI.components.HighScoreHolder(this, cache.highScore);
    
    this.highScoreHolder.setXY(EHDI.GAME.sceneManager.getStageWidth() * 0.67, EHDI.GAME.sceneManager.getStageHeight() * 0.0417);
    
    
    this.playBtn = new EHDI.displays.Button(EHDI.Assets.images["btn_play"], EHDI.Assets.images["btn_play2"], null, null);
    
    this.playBtn.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.5, EHDI.GAME.sceneManager.getStageHeight() * 0.85);
    
    this.addChild(this.playBtn);
    
    this.playBtn.setOnClickFunction(this.startGame);
    
    this.playTxt = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("BTN_PLAY"));
    
    this.playTxt.anchor.set(0.75, 0.5);
    
    this.playBtn.addChild(this.playTxt);


    
    this.tl = new TimelineMax();   
    this.tl.from(this.title, 1, {scaleX:0, scaleY:0, ease: Elastic.easeOut});
    this.tl.from(this.glow, 1, {scaleX:0, scaleY:0, ease: Elastic.easeOut}, "-=0.75");
    this.tl.from(this.purpleCube, 0.5, {x : EHDI.GAME.sceneManager.getStageWidth() * 0.5, y : EHDI.GAME.sceneManager.getStageHeight() * 0.4, scaleX:0, scaleY:0, ease: Power2.easeIn}, "-=0.75");
    this.tl.from(this.greenCube, 0.5, {x : EHDI.GAME.sceneManager.getStageWidth() * 0.5, y : EHDI.GAME.sceneManager.getStageHeight() * 0.4, scaleX:0, scaleY:0, ease: Power2.easeIn}, "-=0.6");
    this.tl.from(this.blueCube, 0.5, {x : EHDI.GAME.sceneManager.getStageWidth() * 0.5, y : EHDI.GAME.sceneManager.getStageHeight() * 0.4, scaleX:0, scaleY:0, ease: Power2.easeIn}, "-=0.45");
    this.tl.from(this.yellowCube, 0.5, {x : EHDI.GAME.sceneManager.getStageWidth() * 0.5, y : EHDI.GAME.sceneManager.getStageHeight() * 0.4, scaleX:0, scaleY:0, ease: Power2.easeIn}, "-=0.3");
    this.tl.from(this.playBtn, 0.25, {scaleX:0, scaleY:0, ease: Back.easeOut});
    
    var repeatTimeline = new TimelineMax({repeat : -1});
    repeatTimeline.to(this.glow, 3, {alpha : 0});
    repeatTimeline.to(this.glow, 1, {alpha : 1});
    
   /* if(!EHDI.GAME.debugUtils) {
        EHDI.GAME.debugUtils = new EHDI.debugUtils.debugUtilsContainer("v0.2.1");
        EHDI.GAME.sceneManager.addNotification(EHDI.GAME.debugUtils);
    }
*/
    if(!EHDI.GAME.bgm)
    {
        EHDI.GAME.soundManager.autoResumeToggle(true);
        EHDI.GAME.bgm = EHDI.GAME.soundManager.playBGM("bgm", 0.8);
    }
};

EHDI.scene.TitleScene.prototype.toggleAudio = function(enable) {
    EHDI.GAME.soundManager.setMute(enable);
    
    EHDI.GAME.soundManager.playSFX("button_sfx");
    var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);
    cache.isMuted = enable;
    EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.id, cache);
}


EHDI.scene.TitleScene.prototype.startGame = function() {
    EHDI.GAME.soundManager.playSFX("button_sfx");
    EHDI.GAME.sceneManager.changeScene(new EHDI.scene.GameScene(), {x : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageWidth(), 0), duration : 0.25});
};

EHDI.scene.TitleScene.prototype.screenDidDisappear = function() {
    this.destroy({children: true});
    // delete this;
}

